<template>
  <v-footer dark padless :fixed="fixed">
    <v-card class="flex" flat tile color="grey lighten-1">
      <v-btn
        color="transparent"
        elevation="0"
        class="p-0 mr-1 btn-menu font-weight-light text-capitalize black--text text--darken-1"
        small
        @click="setPortuguese()"
        style="outline: none;"
      >{{ $t('Home.MenuHome.portuguese') }}</v-btn>

      <v-btn
        color="transparent"
        elevation="0"
        class="p-0 mr-1 btn-menu font-weight-light text-capitalize black--text text--darken-1"
        small
        @click="setEnglish()"
        style="outline: none;"
      >{{ $t('Home.MenuHome.english') }}</v-btn>

      <v-btn
        color="transparent"
        elevation="0"
        class="p-0 mr-1 btn-menu font-weight-light text-capitalize black--text text--darken-1"
        small
        @click="setSpanish()"
        style="outline: none;"
      >{{ $t('Home.MenuHome.spanish') }}</v-btn>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  props: ["fixed"],
  methods: {
    setEnglish() {
      this.$i18n.locale = "en";
      localStorage.locale = "en";
      this.drawer = false;
      location.reload();
    },
    setPortuguese() {
      this.$i18n.locale = "pt";
      localStorage.locale = "pt";
      this.drawer = false;
      location.reload();
    },
    setSpanish() {
      this.$i18n.locale = "es";
      localStorage.locale = "es";
      this.drawer = false;
      location.reload();
    },
  },
};
</script>

<style>
</style>